import React from 'react';
import styled from '@emotion/styled';
import Pill from '~/components/Pill';
import Gap from '~/components/Gap';
import { useInvoiceSummary } from './hooks/useInvoiceSummary';
import { fmPrice } from '~/utils/amount';
import { MOBILE_QRY } from '~/config';

const Wrapper = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;

  ${MOBILE_QRY} {
    gap: 20px;
  }
`;

const Card = styled.div`
  flex: 1 1 150px;
  min-width: 150px;
  padding: 16px;
  border: 1px solid var(--border1);
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);

  ${MOBILE_QRY} {
    padding: 20px;
  }

  .pill {
    width: fit-content;
  }
`;

const TitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #7b7986;
  margin-bottom: 16px;

  > span.title {
    font-size: 14px;
    font-weight: 500;
    line-height: auto;
  }

  > span.sub {
    font-size: 12px;
  }
`;

const Amount = styled.div<{ color?: string }>`
  font-size: 20px;
  font-weight: 600;
  color: ${({ color }) => color || '#000'};

  ${MOBILE_QRY} {
    font-size: 20px;
  }
`;

const InvoiceCard: React.FC<{
  title: string;
  subtitle?: string;
  amount: number;
  count: number;
  color?: string;
  currency: string;
}> = ({ title, subtitle, amount, count, color, currency }) => (
  <Card>
    <TitleRow>
      <span className="title">{title}</span>
      <span className="sub">{subtitle}</span>
    </TitleRow>
    <Amount color={color}>{fmPrice(currency, amount)}</Amount>
    <Gap t={16} />
    <Pill className="pill">{`${count} invoices`}</Pill>
  </Card>
);

const InvoiceSummary: React.FC = () => {
  const { data, currency } = useInvoiceSummary();

  return (
    <Wrapper>
      <InvoiceCard
        title="Draft Invoices"
        // subtitle="All Time"
        amount={data.draft.amount}
        count={data.draft.count}
        currency={currency}
      />
      <InvoiceCard
        title="Paid Invoices"
        // subtitle="This Month"
        amount={data.paid.amount}
        count={data.paid.count}
        currency={currency}
        color="#2e7d32" // green
      />
      <InvoiceCard
        title="Outstanding Invoices"
        // subtitle="All Time"
        amount={data.outstanding.amount}
        count={data.outstanding.count}
        currency={currency}
        color="#1565c0" // blue
      />
      <InvoiceCard
        title="Overdue Invoices"
        amount={data.overdue.amount}
        count={data.overdue.count}
        currency={currency}
        color="#c62828" // red
      />
    </Wrapper>
  );
};

export default InvoiceSummary;
